<p-tree [value]="holdingTreeNodes" selectionMode="single" (onNodeSelect)="selectionChanged($event)"></p-tree>
